import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CustomizationService } from 'src/services/customization.service';
import { CustomizationStoreService } from 'src/services/customization.store.service';

@Component({
  selector: 'vex-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss']
})
export class PolicyComponent {
  userID;
  policy;
  loading = false;
  funderStyles;
  funderConfig;

  constructor(private customizationStoreService: CustomizationStoreService, @Inject(MAT_DIALOG_DATA) public data: { flow: string, lang: string | null, allData: any | null }) {
    // set Customization data when CustomizationService request is completed
    console.warn(this.data)
    this.customizationStoreService.getFunderStyles().subscribe(
      (customization) => {
        if (Object.keys(customization).length > 0) {
          this.funderStyles = customization;
        }
      },
    );

    this.customizationStoreService.getFunderConfig().subscribe(
      (config) => {
        
        if (Object.keys(config).length > 0) {
          this.funderConfig = config;
          this.setCustomization(this.funderConfig);
        }
      },
    );
  }

  setCustomization(config) {
     this.loading = true;
     console.error(this.data)
    if(this.data && this.data.flow && this.data.allData && this.data.allData[this.data.flow] && this.data.allData[this.data.flow].texts && this.data.allData[this.data.flow].texts.policy) {
      this.policy = this.data.allData[this.data.flow].texts.policy;
    } else if(this.data && this.data.flow && this.data.allData && this.data.allData[this.data.flow] && this.data.allData[this.data.flow].config_translate && this.data.allData[this.data.flow].config_translate.policy) {
      this.policy = this.data.allData[this.data.flow].config_translate.policy;
    } else if (config && config.policy) {
      this.policy = config.policy;
    } 
    this.loading = false;
  }
}
